import React from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';

const NotFoundPage: React.FC = () => {
  return (
    <PageWrapper title='Seite nicht gefunden'>
      <div className='margin-vertical-xl align-center'>
        <h1 className='margin-none'>Hinweis Fehler 404</h1>
        <h5 className='margin-none'>Die gewünschte Seite konnte leider nicht gefunden werden.</h5>
        <div>
          <img
            alt='errorImage'
            src='//www.static-immobilienscout24.de/statpic/error-page/1b897f0c0bc19ff74d68346f75fdef25_IS24_ErrorPage.svg'
            onError={() => "this.src='//etc/designs/is24/img/immoscout24.png';this.onerror=null;"}
            style={{ height: 200 }}
          />
          <p className='font-bold margin-bottom-s'>Bitte Überprüfen Sie:</p>
          <ul className='list-bullet inline-block align-left margin-bottom-l'>
            <li>die Schreibweise der URL (Groß- und Kleinschreibung beachten!)</li>
            <li>Ihren Bookmark</li>
            <li>die Seite, von der Sie gekommen sind</li>
          </ul>

          <p className='margin-bottom-l'>
            Ansonsten klicken Sie auf den Zurück-Button Ihres Browsers oder auf einen
            <br /> der unten angegebenen Links, um in unser Angebot zurück zu kommen.
          </p>
          <a href='/' className='button-primary margin-bottom-l'>
            Zur Startseite
          </a>
          <p>Vielen Dank für Ihr Verständnis!</p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NotFoundPage;
